export default __webpack_public_path__ + "static/media/banzuduibi.be48b1a2.svg";